import { ArrowRightIcon, StoreIcon } from "lucide-react"
import Link from "next/link"
import { Button } from "@/components/ui/button"
import { getSession } from "@/services/auth-service"

const DEFAULT_ACCOUNT_NAME = "Cliente"

const toAccountDisplayName = (
  user: {
    name?: string | null
    email?: string | null
  } | null
): string => {
  const name = user?.name?.trim()

  if (name) {
    return name
  }

  const email = user?.email?.trim()

  if (email) {
    return email
  }

  return DEFAULT_ACCOUNT_NAME
}

export default async function MinhaContaPage() {
  const session = await getSession()
  const accountDisplayName = toAccountDisplayName(session?.user ?? null)

  return (
    <div className='space-y-6'>
      <section className='rounded-2xl border bg-white p-6 shadow-xs md:p-8'>
        <div className='max-w-3xl space-y-4'>
          <h1 className='font-semibold text-3xl text-foreground'>
            Ola, {accountDisplayName}
          </h1>

          <p className='text-base text-muted-foreground leading-7'>
            A partir do painel da sua conta, voce pode ver suas compras
            recentes, gerenciar seus enderecos de entrega e cobranca e editar os
            detalhes da sua conta.
          </p>

          <div className='flex flex-wrap gap-3'>
            <Button asChild>
              <Link href='/minha-conta/pedidos'>Ver pedidos</Link>
            </Button>

            <Button asChild variant='outline'>
              <Link href='/minha-conta/detalhes-da-conta'>Editar perfil</Link>
            </Button>
          </div>
        </div>
      </section>

      <section className='rounded-2xl border bg-white p-6 shadow-xs md:p-8'>
        <div className='flex flex-col gap-6 md:flex-row md:items-center md:justify-between'>
          <div className='max-w-2xl space-y-2'>
            <div className='flex items-center gap-3'>
              <div className='rounded-full bg-primary/10 p-3 text-primary'>
                <StoreIcon aria-hidden='true' size={18} />
              </div>
              <h2 className='font-semibold text-xl'>Become a Vendor</h2>
            </div>

            <p className='text-base text-muted-foreground leading-7'>
              Vendors can sell products and manage a store with a vendor
              dashboard.
            </p>
          </div>

          <Button asChild className='md:self-start'>
            <Link href='/vendor/become-a-vendor'>
              Become a Vendor
              <ArrowRightIcon aria-hidden='true' size={16} />
            </Link>
          </Button>
        </div>
      </section>
    </div>
  )
}
